<template>
  <z-form ref="form">
    <template slot="default" slot-scope="{ invalid }">
      <base-modal :is_loading="is_content_loading">
        <z-form-group class="row mb-0">
          <div class="col-12">
            <z-form-input
              :rules="{ required: true, min: 1 }"
              :show_errors="false"
              mode="aggressive"
            >
              <i-select v-model="selected" :multiple="true" :filtrable="true">
                <i-option
                  v-for="item in items"
                  :key="item.id"
                  :value="item.id"
                  :label="item.number"
                />
              </i-select>
            </z-form-input>
          </div>
        </z-form-group>

        <i-button
          slot="footer-ok"
          type="success"
          size="large"
          :disabled="invalid"
          :loading="is_button_loading"
          @click="save"
        >
          {{ $t('shared.component.button.save') }}
        </i-button>
      </base-modal>
    </template>
  </z-form>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { NumberService } from '@call-tracking/services/NumberService';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      BaseModal
    },

    data: () => ({
      items: [],
      selected: [],
      is_content_loading: false,
      is_button_loading: false
    }),

    created() {
      this.is_content_loading = true;

      NumberService.getCandidates()
        .then(res => (this.items = res[DATA]))
        .catch(e => this.$noty.server_error(e))
        .finally(() => (this.is_content_loading = false));
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_button_loading = true;
            const request = NumberService.createItem(this.selected);

            request
              .then(res => this.$emit('success', res))
              .catch(e => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
